// extracted by mini-css-extract-plugin
module.exports = {"poetrycard":"promos_poetrycard__RTQL8"};